import { useApolloClient } from '@apollo/client';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from '@mui/material';

import { useTranslation } from 'react-i18next';

import USER_QUERY from 'gql/queries/currentUser.gql';

import { useCompaniesMutation } from 'api/hooks/jobmarket/companies';
import { translations } from 'locales/i18n';
import { useAuthContext } from 'utils/hooks/useAuthContext';

interface Props {
  dialogOpen: boolean;
  setShowNewsletterDialog: (show: boolean) => void;
}

export const NewsletterDialog = (props: Props) => {
  const { t } = useTranslation();
  const client = useApolloClient();

  const { user: currentUser } = useAuthContext();

  const { update } = useCompaniesMutation();

  const handleNewsLetterDialogClose = () => {
    props.setShowNewsletterDialog(false);
  };

  const handleConfirm = async () => {
    await update.mutateAsync(
      { id: currentUser.company.id, data: { agreedToNewsletter: true } },
      {
        onSuccess: () => {
          client.refetchQueries({ include: [USER_QUERY] });
        }
      }
    );
    handleNewsLetterDialogClose();
  };

  const handleDeny = async () => {
    await update.mutateAsync(
      { id: currentUser.company.id, data: { agreedToNewsletter: false } },
      {
        onSuccess: () => {
          client.refetchQueries({ include: [USER_QUERY] });
        }
      }
    );
    handleNewsLetterDialogClose();
  };

  return (
    <Dialog open={props.dialogOpen}>
      <DialogTitle>
        {t(translations.pages.companyDetailPage.dialogs.newsletterConfirmationTitle())}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {t(translations.pages.companyDetailPage.dialogs.newsletterConfirmationText())}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleDeny} color="error" variant="outlined" size="small">
          {t(translations.common.deny())}
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained" size="small">
          {t(translations.common.accept())}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
